import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../App/Components/Form/TextInput/TextInput'

import { IProps } from './IProps'

export const EmailInputField: FunctionComponent<IProps> = ({
    setPersonEmail,
    setEmailWarning,
}) => {
    const { t } = useTranslation()

    const validateEmail = (email: string) => {
        setPersonEmail(email)

        const validDomains = [
            'gmail.com',
            'outlook.com',
            'icloud.com',
            'yahoo.com',
            'msn.com',
        ]

        const emailDomain = email.split('@')[1]

        if (!validDomains.includes(emailDomain)) {
            for (const domain of validDomains) {
                if (domain.startsWith(emailDomain)) {
                    setEmailWarning(`${t('Did you mean')} @${domain}?`)
                    return false
                }
            }
        }

        setEmailWarning('')
        return true
    }

    return (
        <div
            style={{
                margin: '0.7em 0',
            }}
        >
            <TextInput
                label={t('E-mail')}
                type={'email'}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    validateEmail(e.currentTarget.value)
                }
            />
        </div>
    )
}
